<template>
  <div class="jobs-list" v-loading="loader">
    <div class="notify" v-if="$route.params.id">
      Создайте работу для этого обьекта плюсом в верхнем правом углу
    </div>
    <div style="display: flex; flex-direction: column">
      <a :href="dirUrl" target="_blank" style="width: 100%" v-if="$route.name !== 'PROF'">
        <el-button size="small" style="width: 100%">
          Выгрузить в эксель
        </el-button>
      </a>
      <ImportJobs
        v-if="!$route.name || $route.name === 'JOB'" @update="updateJobs" :name="tr[$route.name]"/>

      <ImportMaterials
        v-if="!$route.name || $route.name === 'MATERIALS'" @update="updateJobs"/>
    </div>
    <div class="checkbox-list" v-if="$route.name === 'PROF' || $route.name === 'TECH'">
      <el-checkbox @change="changeTimeAvailable" v-model="available_reports[`${$route.name}_TIME`]"></el-checkbox>
      <span>Учет по часам (* добавляет поле “Часы” в отчете)</span>
    </div>
    <div class="checkbox-list" v-if="$route.name === 'PROF'">
      <el-checkbox @change="changeTimeAvailable" v-model="available_reports[`${$route.name}_ALL`]"></el-checkbox>
      <span>Выводить все проффесии в отчет</span>
    </div>
    <el-form>
      <filter-select
        v-if="$route.name === 'MATERIALS'"
        v-model="object"
        label="Выберите объект"
        :options="list"
      />
    </el-form>
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <draggable
      class="jobs-ul"
      handle=".handle"
      :list="jobs"
      @change="save"
    >
      <div class="jobs-li" v-for="(job, index) in filteredList" :key="index">
        <div class="jobs-text">
          <i class="fa fa-align-justify handle"></i>
          <span>{{ job.name }}</span>
        </div>
        <router-link v-if="$route.name === 'MATERIALS'"
                     :to="`/dashboard/materials/${job.id}/edit${$route.query.plan ? '?plan=' + $route.query.plan + '&name=' + $route.query.name : ''}${$route.query.version ? '&version=' + $route.query.version + '&name=' + $route.query.name : ''}`"
                     key="1">
          <i class="fa fa-edit"></i>
        </router-link>
        <router-link v-else
                     :to="`/dashboard/jobs/${job.id}/edit/${$route.name}?type=${job.type || 'JOB'}${$route.query.plan ? '&plan=' + $route.query.plan + '&name=' + $route.query.name : ''}${$route.query.version ? '&version=' + $route.query.version + '&name=' + $route.query.name : ''}&list=true`"
                     key="2">
          <i class="fa fa-edit"></i>
        </router-link>
      </div>
    </draggable>

    <router-link :to="getUrl()" class="add-job">
      <el-button>+ Добавить {{ tr[$route.name] }}</el-button>
    </router-link>
  </div>
</template>

<script>
import firebase from 'firebase';
import draggable from 'vuedraggable';
import _ from 'lodash';
import ImportJobs from './components/Importjobs';
import {getChildList} from '../../../utils/getChild';
import FilterSelect from '../../../components/FilterSelect';
import ImportMaterials from "./components/ImportMaterials";
import {apiUrl} from "../../../plugins/firebase";


export default {
  name: 'List',
  components: {ImportMaterials, FilterSelect, ImportJobs, draggable},

  data() {
    return {
      loader: false,
      search: '',
      jobs: [],
      list: [],
      permission: [],
      object: null,
      available_reports: {
        JOB: true,
        TECH: true,
        PROF: true,
        COVID: true,
        TECH_TIME: false,
        PROF_TIME: false,
        MATERIALS: false,
        TASKS: false,
        PROF_ALL: false,
      },
      tr: {
        JOB: 'работу',
        PROF: 'профессию',
        TECH: 'технику',
        MATERIALS: 'материалы',
      },
    };
  },
  async mounted() {
    this.fetchJobs();

    const available_reports = this.$store.state.project.available_reports || {};

    if (this.available_reports) {
      this.available_reports = {
        ...this.available_reports,
        ...available_reports,
      };
    }

    if (this.$route.name === 'MATERIALS') {
      this.fetchTree();
    }
  },

  methods: {
    fire() {
      if (this.$route.query.plan) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan)
      }

      if (this.$route.query.version) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    updateJobs() {
      this.fetchJobs();
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        const r = _.orderBy(getChildList(result), 'index', ['asc']);
        this.list = [
          {
            label: 'Показать все',
            value: null,
          },
          {
            label: 'Без объекта',
            value: 'all',
          },
          ...r.map((r) => {
            return {
              label: r.name,
              value: r.id,
            };
          })];
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    save: _.debounce(function (el, binding) {
      const jobs = this.jobs.map((job, index) => {
        delete job.job;
        return {
          ...job,
          _data: {
            ...job._data,
            index: index,
          },
        };
      });

      this.update(jobs);
    }, 1000),
    changeTimeAvailable() {
      this.fire()
        .update({
          ...this.form,
          available_reports: this.available_reports,
        }).then(() => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });
        this.$store.dispatch('setProject', {
          ...this.$store.state.project,
          available_reports: this.available_reports,
          id: this.$store.state.project.id,
        });
      })
        .catch((error) => console.log(error));
    },
    update(jobs) {
      let batch = myFirestore.batch();
      jobs.forEach((doc) => {
        const docRef = this.fire()
          .collection('jobs')
          .doc(doc.id);
        delete doc._data.job;
        batch.update(docRef, doc._data);
      });
      batch.commit();
    },
    getUrl() {
      let url = `/dashboard/jobs/${this.$route.query.obj || this.$route.params.id || 'new'}/create/`;
      if (this.tr[this.$route.name]) {
        url = url + this.$route.name;
      }

      if (this.$route.name === 'MATERIALS') {
        if (this.object && this.object.value) {
          return '/dashboard/materials/create?obj=' + this.object.value;
        }
        return '/dashboard/materials/create';
      }

      if (this.$route.query.plan) {
        return url + `${this.$route.query.plan ? '?plan=' + this.$route.query.plan + '&name=' + this.$route.query.name : ''}`;
      }

      if (this.$route.query.version) {
        return url + `${this.$route.query.version ? '?version=' + this.$route.query.version + '&name=' + this.$route.query.name : ''}`;
      }

      return url;
    },
    fetchJobs() {
      this.loader = true;
      const result = [];
      let req = null;
      if (this.$route.params.id) {
        req = this.fire()
          .collection('jobs')
          .where(`objects`, 'array-contains-any', [this.$route.params.id])
          .where('type', '==', 'JOB');
      } else {
        req = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('jobs')
          .where('type', '==', this.$route.name || 'JOB');
      }
      req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              _data: data,
            });
          });
        })
        .finally(() => {
          this.jobs = _.orderBy(result, '_data.index', ['asc']);
          this.loader = false;
        });
    },
  },

  computed: {
    dirUrl() {
      let query = ''
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        query = '?planId=' + this.$store.state.project.plan.id
      }

      if (this.$store.state.project.version && this.$store.state.project.version.id) {
        query = '?planId=' + this.$store.state.project.version.id
      }

      const params = encodeURIComponent(`/onGenerateSpecialJobs/${this.$store.state.project.id}${query}`)
      return `${apiUrl}${params}`;
    },
    filteredList() {
      return this.jobs.filter((job) => {
        const search = job.name.toLowerCase().includes(this.search.toLowerCase());
        if (this.object && this.object.value) {
          return search && job._data.objects.includes(this.object.value);
        }
        return search;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 428px;
  width: calc(100% - 40px);
  margin: 22px auto;
  padding-top: 20px;
}

.jobs-text {
  display: flex;
  align-items: center;

  .handle {
    margin-right: 30px;
  }
}

.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    height: auto !important;
    padding: 8px 12px;
    text-align: left;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-edit {
  color: #000;
}

.checkbox-list {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;

  i {
    margin-right: 10px;
  }

  span {
    text-align: left;
    font-size: 14px;
    margin-left: 8px;
  }
}

.jobs-list {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/List.vue